import React from 'react';
import { FaBookOpen, FaCalendarAlt, FaExclamationCircle, FaUserFriends } from 'react-icons/fa';
import {
  StatsGrid as StatsGridContainer,
  StatCard,
  StatIcon,
  StatNumber,
  StatLabel,
} from './StatsGrid.styles';

const stats = [
  {
    icon: <FaBookOpen size={40} color="#223046" />,
    number: '3.72',
    label: 'Current GPA',
    onClick: () => alert('GPA details coming soon!'),
  },
  {
    icon: <FaCalendarAlt size={40} color="#7B2639" />,
    number: '16',
    label: 'Credits This Semester',
    onClick: () => alert('Credits details coming soon!'),
  },
  {
    icon: <FaExclamationCircle size={40} color="#F5B700" />,
    number: '45',
    label: 'Days Until Finals',
    onClick: () => alert('Finals info coming soon!'),
  },
  {
    icon: <FaUserFriends size={40} color="#3B7C5A" />,
    number: '3',
    label: 'Club Memberships',
    onClick: () => alert('Clubs info coming soon!'),
  },
];

const StatsGrid: React.FC = () => {
  return (
    <StatsGridContainer>
      {stats.map((stat) => (
        <StatCard key={stat.label} onClick={stat.onClick} tabIndex={0} role="button">
          <StatIcon>{stat.icon}</StatIcon>
          <StatNumber>{stat.number}</StatNumber>
          <StatLabel>{stat.label}</StatLabel>
        </StatCard>
      ))}
    </StatsGridContainer>
  );
};

export default StatsGrid;


